import _get from 'lodash/get';

import { FETCH_VEHICLES, UPDATE_VEHICLE, BULK_UPDATE_VEHICLE, RESET_VEHICLE_DATA } from './action';
import { SUCCESS, FAILURE, REQUEST } from 'utils/actionGenerator';

const defaultState = {};

export default function (state = defaultState, action) {
  switch (action.type) {
    case FETCH_VEHICLES[SUCCESS]: {
      return { ...state, vehicleList: action.response.data };
    }
    case FETCH_VEHICLES[FAILURE]: {
      return { ...state, vehicleList: [] };
    }
    case UPDATE_VEHICLE[REQUEST]: {
      return { ...state, vehicleUpdated: false };
    }
    case UPDATE_VEHICLE[SUCCESS]: {
      return { ...state, vehicleUpdated: true };
    }
    case UPDATE_VEHICLE[FAILURE]: {
      return { ...state, vehicleUpdated: false };
    }

    case BULK_UPDATE_VEHICLE[REQUEST]: {
      return { ...state, vehicleUpdated: false };
    }

    case BULK_UPDATE_VEHICLE[SUCCESS]: {
      return { ...state, vehicleUpdated: true, validationObj: {} };
    }

    case BULK_UPDATE_VEHICLE[FAILURE]: {
      return {
        ...state,
        vehicleUpdated: false,
        validationObj: action.response.vehicles,
      };
    }

    case RESET_VEHICLE_DATA[REQUEST]: {
      return { ...state, vehicleList: [] };
    }

    default:
      return state;
  }
}

export const getVehicleList = (state) => _get(state, 'updateVehicle.vehicleList', []);
export const isVehicleUpdated = (state) => _get(state, 'updateVehicle.vehicleUpdated', false);
export const getValidationObj = (state) => _get(state, 'updateVehicle.validationObj');
